export default __webpack_public_path__ + "df147a19521e98ee86fe4e446adb53c9.ttf";